import { IPackage } from '../graphQL/commons'
import { IConfig, IPackageProduct } from '../interfaces'
import formatPrice, { stripHiddenPrice } from './formatPrice'
import { resolvePackageSort } from './packageSort'
import sortByKey from './sort'

export const sanitizeExtraPackages = (
  source: IPackage[],
  config?: IConfig,
): IPackageProduct[] => {
  const packages: IPackageProduct[] = source.map((packageSource) => {
    const currency: string | undefined =
      config?.options?.currency || config?.options?.currencySymbol
    const format: string | undefined = config?.options?.format
    return {
      ...packageSource,
      suffix: stripHiddenPrice(
        formatPrice({
          currency,
          format,
          price: packageSource.price,
          hidePrices: config?.options?.hidePricesActive,
        }),
      ),
    }
  })

  const sort = resolvePackageSort(config?.globals?.packages?.sort)

  if (!sort) {
    return packages
  }

  return sortByKey<IPackageProduct>(packages, sort.field, sort.reverse)
}
